import React, { Component } from "react"
import PropTypes from "prop-types"
import Highcharts from "highcharts"
import Exporting from "highcharts/modules/exporting"
import { translate } from "react-i18next"
import ColumnChartShape from "../../../state/shapes/ColumnChartShape"
import { CHARTS } from "../../../constants"
import { formatDecimalForDisplay } from "../../../utils/formatting-utils"

class ColumnChart extends Component {
  componentDidMount = () => {
    // Get the element into which to insert the chart
    const chartContainer = this.chartContainerRef

    const {
      xAxisTitle,
      yAxisTitle,
      t,
      data,
      overrideColours,
      isPercentageBased,
      tooltipFormatter,
      titleKey,
      subtitleKey
    } = this.props
    // Null as widget titleKey describes chart
    const categories = data.categories.map((c) => {
      return t(c)
    })
    const bars = data.bars.map((b) => {
      return {
        data: b.data,
        name: t(b.name),
        showInLegend: b.showInLegend === undefined ? true : b.showInLegend,
      }
    })

    Exporting(Highcharts)

    // Create the chart
    this.chart = new Highcharts.Chart({
      chart: {
        renderTo: chartContainer,
        height: CHARTS.standardHeight,
        type: "column",
      },
      lang: {
        contextButtonTitle: t("Common.ChartDownloadOptions"),
      },
      title: {
        text: titleKey != null && titleKey.length > 0 ? t(titleKey) : null,
        y: -30
      },
      subtitle: {
        text: subtitleKey != null && subtitleKey.length > 0 ? t(subtitleKey) : null,
        y: -15
      },
      credits: {
        enabled: false,
      },
      colors: overrideColours || CHARTS.getColours(bars.length),
      xAxis: {
        categories,
        titleKey: {
          text: t(xAxisTitle),
        },
      },
      yAxis: {
        min: 0,
        titleKey: {
          text: t(yAxisTitle),
        },
        labels: {
          overflow: "justify",
        },
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true,
          },
        },
        series: {
          animation: CHARTS.animationEnabled,
          minPointLength: 2,
        },
      },
      series: bars,
      tooltip: {
        enabled: true,
        formatter() {
          if (tooltipFormatter) {
            return tooltipFormatter(this)
          }
          return `<span style="color:${this.point.color}">\u25CF</span>${
            this.key
          }: ${formatDecimalForDisplay(this.point.y)}${isPercentageBased ? "%" : ""}`
        },
      },
      exporting: {
        enabled: CHARTS.exportEnabled,
        buttons: {
          contextButton: {
            menuItems: CHARTS.exportButtons,
          },
        },
        filename: titleKey != null && titleKey.length > 0 ? t(titleKey) : null,
        chartOptions: CHARTS.exportChartOptions,
      },
    })
  }

  componentWillUnmount = () => {
    this.chart.destroy()
  }

  render() {
    return (
      <div
        className="chart-container col-md-12"
        ref={(c) => {
          this.chartContainerRef = c
        }}
      />
    )
  }
}

ColumnChart.propTypes = {
  data: PropTypes.shape(ColumnChartShape).isRequired,
  yAxisTitle: PropTypes.string.isRequired,
  xAxisTitle: PropTypes.string,
  t: PropTypes.func.isRequired,
  overrideColours: PropTypes.arrayOf(PropTypes.string),
  isPercentageBased: PropTypes.bool,
  tooltipFormatter: PropTypes.func,
  titleKey: PropTypes.string,
  subtitleKey: PropTypes.string
}

ColumnChart.defaultProps = {
  xAxisTitle: undefined,
  overrideColours: null,
  isPercentageBased: false,
  tooltipFormatter: null,
  titleKey: '',
  subtitleKey: ''
}

export default translate()(ColumnChart)



// WEBPACK FOOTER //
// ./src/components/charts/generic/ColumnChart.jsx